import React, { useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import { toast } from 'react-toastify';
import Loading from "~/components/layout/Loading";
import { formatCNPJ, checkSubString } from '~/utils/utils';
import { 
  CloseIconContainer,
  ModalContent,
  Title,
  ButtonArea,
  Button,
  ButtonLink,
  BodyContent,
  Caption,
  ImagePush
} from '../styles';

export default function NotificationPushModal({ showModalPush, setShowModalPush, notification}) {
  const history = useHistory();
  const toastId = useRef(null);
  const host_name = window.location.host;

  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    setShowModal(showModalPush);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalPush]);

  useEffect(() => {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    }

    fetchTracking({
      bulletinsid: notification.id,
      cnpj: document
    })

    if (!notification.hiperlinks && !notification.content) {
      fetchTrackingRead(notification.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchTrackingRead(id) {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    } else {
      document = formatCNPJ(localStorage.getItem('document'));
    }

    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        {
          bulletinsid: id,
          cnpj: document
        },
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - push notification.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - push notification.", error);
      return false
    }
  }

  async function fetchTracking(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/calls',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking call - popup.", err);
      });
    } catch (error) {
      console.warn("Exceção in tracking - Popup.", error);
      return false
    }
  }

  function onOpenPush() {
    setShowModal(false);
    setShowModalPush(false);
  }

  return (
    showModal && !toast.isActive(toastId.current) && !notificationReducer.activePopup && (
      <>
        {toast.success(
          <ModalContent onClick={() => onOpenPush() }>
            <BodyContent>
              {/* <ImagePush>
                {notification?.cover && (
                  <img src={notification.cover } alt="Cover push" />
                )}
              </ImagePush> */}
              <Title>
                <span>{notification?.title && notification.title}</span>
              </Title>
              <Caption>
                {notification?.caption && notification.caption}
              </Caption>
              {notification?.hiperlinks && (
                <ButtonLink style={{ cursor: 'pointer' }}>
                  <a
                    onClick={() => fetchTrackingRead(notification.id) }
                    href={notification.hiperlinks}
                    target={checkSubString(notification.hiperlinks, host_name) ? "_self" : "_blank" }
                  >
                    Saiba mais
                  </a>
                  {' '}
                  <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
                </ButtonLink>
              )}
              {!notification?.hiperlinks && notification?.content && (
                <ButtonLink onClick={() => history.push(`/segmented-comunication-details?id=${notification.id}`)} style={{ cursor: 'pointer' }}>
                  Saiba mais {' '}
                  <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
                </ButtonLink>
              )}
            </BodyContent>
          </ModalContent>,{
            toastId: ' ',
            containerId: 'push',
            closeOnClick: true
          }
        )}
      </>
    )
  );
}
